'use client';

import { atom } from 'jotai';

export const nlsToggleAtom = atom(false);
